export default {
  // Dialog title
  title: "Modify Label",

  // Form related
  pleaseSelect: "Please select",
  pleaseInput: "Please input",
  pleaseInputContent: "Please enter content",

  // Buttons
  addLabel: "Add Label",
  reset: "Reset",

  // Validation messages
  requiredFieldError: "Required fields marked with * must be filled",
  addLabelSuccess: "This data has been successfully labeled",
};
